import SelectField from '@/components/select-field'
import FormGroup from '@/core/components/FormGroup'
import { Input } from '@/components/ui'
import {
  TOPUP_MODES,
  TOPUP_MODES_REQUIRING_MIN_AMOUNT,
  TopupMode,
  TopupQuestConfigDto,
} from '@/common/models/gamification'

import { CardNetworkCheckboxes } from './CardNetworkCheckboxes'

interface TopupConfigFieldsProps {
  value: TopupQuestConfigDto
  onChange: (next: TopupQuestConfigDto) => void
}

/** Editor for a TOPUP quest's config (mode / minAmount / cardNetworks). */
export const TopupConfigFields = ({
  value,
  onChange,
}: TopupConfigFieldsProps) => {
  const requiresMinAmount = TOPUP_MODES_REQUIRING_MIN_AMOUNT.includes(
    value.mode,
  )
  const minAmountError =
    requiresMinAmount && (value.minAmount === undefined || value.minAmount <= 0)

  return (
    <div className="space-y-6">
      <SelectField
        label="Mode"
        required
        placeholder="Select mode"
        value={value.mode}
        onValueChange={(v) => onChange({ ...value, mode: v as TopupMode })}
        options={TOPUP_MODES.map((m) => ({ value: m, label: m }))}
      />

      <FormGroup
        label="Minimum amount"
        error={
          minAmountError
            ? 'Required and must be greater than 0 for this mode'
            : undefined
        }
      >
        <div>
          <Input
            type="number"
            step="0.01"
            min="0"
            placeholder={
              requiresMinAmount ? '0.00' : 'Optional (empty = any amount)'
            }
            isInvalid={minAmountError}
            value={value.minAmount ?? ''}
            onChange={(e) =>
              onChange({
                ...value,
                minAmount:
                  e.target.value === '' ? undefined : Number(e.target.value),
              })
            }
          />
          <span className="mt-1 block text-xs text-monochrome-2">
            Required for SINGLE and CUMULATIVE; optional for ANY and FIRST.
          </span>
        </div>
      </FormGroup>

      <CardNetworkCheckboxes
        value={value.cardNetworks}
        onChange={(cardNetworks) => onChange({ ...value, cardNetworks })}
      />
    </div>
  )
}
